import { I18nService } from '@app/core/services/i18n.service';

export function i18nAppInitializer(i18n: I18nService): () => Promise<unknown> {
  return () => i18n.init();
}
